'use client';

import { createContext, useContext, useMemo } from 'react';

/**
 * UserProfileContext - Provides user profile data to components.
 *
 * Note: The isInLeadProgram field was removed as part of SUN-35
 * (removing lead program references). This context is kept for
 * potential future user profile data needs.
 */
type UserProfileContextType = Record<string, never>;

export const UserProfileContext = createContext<UserProfileContextType | undefined>(undefined);

export function UserProfileProvider({ children }: { readonly children: React.ReactNode }) {
  const value = useMemo(() => ({}), []);

  return <UserProfileContext.Provider value={value}>{children}</UserProfileContext.Provider>;
}

export function useUserProfile() {
  const context = useContext(UserProfileContext);
  if (!context) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context;
}
